import { render, staticRenderFns } from "./OrganAuditDialog.vue?vue&type=template&id=622637e8&scoped=true&"
import script from "./OrganAuditDialog.vue?vue&type=script&lang=js&"
export * from "./OrganAuditDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrganAuditDialog.vue?vue&type=style&index=0&id=622637e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622637e8",
  null
  
)

export default component.exports